import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";
import { RustyRoyalCoin } from "../../utils/SvgIcons";
const CompareListDataTable = ({ myData, myClass }) => {
  const [data, setData] = useState();

  useEffect(() => {
    setData(myData);
  }, [myData]);
  const columnDefs = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Current Price",
      selector: (row) => (
        <p className="d-flex m-0 p-1" style={{}}>
          <RustyRoyalCoin size={16} />{" "}
          <div className="pl-1">{row?.currentPrice}</div>
        </p>
      ),
      sortable: true,
    },
    {
      name: "Old Price",
      selector: (row) => (
        <p className="d-flex m-0 p-1" style={{}}>
          <RustyRoyalCoin size={16} />{" "}
          <div className="pl-1">{row?.oldPrice}</div>
        </p>
      ),
      sortable: true,
    },
    {
      name: "Price Change",
      selector: (row) => (
        <p className="d-flex m-0 p-1" style={{}}>
          <RustyRoyalCoin size={16} />{" "}
          <div className="pl-1">{row?.priceChange?.toFixed(2)}</div>
        </p>
      ),
      sortable: true,
    },
  ];

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}
        >
          <DataTable
            data={data}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
            selectableRows
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};

export default CompareListDataTable;
